import React, { useState } from 'react';
import './TaskCard.css';

const TaskCard = ({ 
  title = "Sample Task", 
  description = "This is a sample task description", 
  priority = "medium",
  initialCompleted = false,
  onToggle,
  onDelete 
}) => {
  const [completed, setCompleted] = useState(initialCompleted);
  const [isHovered, setIsHovered] = useState(false);

  const handleToggle = () => {
    const newCompleted = !completed;
    setCompleted(newCompleted);
    if (onToggle) {
      onToggle(newCompleted);
    }
  };

  const handleDelete = () => {
    if (onDelete) {
      onDelete();
    }
  };

  const getPriorityColor = () => {
    switch (priority) {
      case 'high': return '#ff6b6b';
      case 'medium': return '#feca57';
      case 'low': return '#48dbfb';
      default: return '#feca57';
    }
  };

  const getPriorityIcon = () => {
    switch (priority) {
      case 'high': return '🔥';
      case 'medium': return '⚡';
      case 'low': return '🌱';
      default: return '⚡';
    }
  };

  return (
    <div 
      className={`task-card ${completed ? 'completed' : ''} ${isHovered ? 'hovered' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="task-header">
        <div className="task-priority" style={{ backgroundColor: getPriorityColor() }}>
          <span className="priority-icon">{getPriorityIcon()}</span>
          <span className="priority-text">{priority.toUpperCase()}</span>
        </div>
        <button 
          className="delete-btn"
          onClick={handleDelete}
          aria-label="Delete task"
        >
          ✕
        </button>
      </div>
      
      <div className="task-content">
        <h3 className="task-title">{title}</h3>
        <p className="task-description">{description}</p>
      </div>
      
      <div className="task-footer">
        <button 
          className={`toggle-btn ${completed ? 'completed' : ''}`}
          onClick={handleToggle}
        >
          <span className="checkmark">{completed ? '✓' : ''}</span>
          {completed ? 'Completed' : 'Mark Complete'}
        </button>
      </div>
      
      <div className="card-overlay"></div>
    </div>
  );
};

export default TaskCard; 